import { Help , HelpParameters } from "./Help";
import { IHelpFactory } from "./IHelpFactory"
export class HelpFactory implements IHelpFactory
{
    public CreateNewHelp(params: HelpParameters): Help
    {
        return new Help(params);
    }
}

